module.exports = __webpack_public_path__ + "static/media/gryphon-house-sidewalk.05611cd5.jpg";